module.exports = __webpack_public_path__ + "media/images/three-dots-white-40e7c726b2f73fc25dbd579995f8e392.svg";